<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="form-group pt-3" v-if="this.lista">
          <label>Equipment</label>
          <input type="text" class="form-control" name="inpsel_equipment_id" autocomplete="off"
            placeholder="Equipment Name" @change="searching(0)" list="equipment-list" id="inpsel_equipid"
            v-model.number="search" />
          <datalist id="equipment-list">
            <option :value="equipment.id" :data-id="equipment.id" v-for="equipment in this.lista" :key="equipment">
              {{ equipment.name }}
            </option>
          </datalist>
        </div>
        <div class="input-group" v-else-if="showSearch">
          <div class="form-outline">
            <input type="search" id="form1" class="form-control" placeholder="Search" v-model="search"
              @change="searching(0)" />
          </div>
          <button type="button" class="btn btn-primary">
            <i class="fas fa-search"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <data-table :headers="headers" :actions="actions" :items="items" />
  <pagination :length="length" :onPageChange="pageChange" />
</template>

<script>
  import DataTable from "data-table/src/components/DataTable.vue";
  import Pagination from "data-table/src/components/Pagination.vue";
  export default {
    name: "DataTable2",
    components: { Pagination, DataTable },
    data() {
      return {
        items: [],
        length: 0,
        max: 0,
        search: null
      }
    },
    props: {
      actions: Array,
      headers: Object,
      api: Function,
      fields: Array,
      mainfilter: Object,
      trigger: Object,
      lista: Array,
      showSearch:Boolean
    },
    methods: {
      async searching(skip) {
        let search = { ...this.mainfilter };
        if (this.search !== null && this.search !== undefined && this.search !== '') {
          this.fields.forEach(field => {
            search = { ...search, [field]: this.search };
          })
        }
        let data = await this.api(search, skip, this.max);
        this.length = data.count;
        this.items = data.data;
      },
      pageChange(page, max) {
        this.max = max;
        let skip = (page - 1) * max;
        this.searching(skip);
      }
    },
    created() {
      this.pageChange(1);
      let trigger = this.trigger;
      if (trigger)
        trigger.refresh = () => {
          this.pageChange(1);
        }
    },

  }
</script>

<style scoped></style>